import React from 'react';
import T from 'components/T';
import { M } from '@dashboard-experience/mastodon';
import { CHECKR_APPLICANT_FAQ_PAGE } from '../../constants';

const FaqButton = () => (
  <M.Link
    href={CHECKR_APPLICANT_FAQ_PAGE}
    target='_blank'
    rel='noopener noreferrer'
    className='btn-faq'
  >
    <M.Button kind='secondary'>
      <T value='buttons.helpCenter' />
    </M.Button>
  </M.Link>
);

export default FaqButton;
